// element-ui按需引入集成
import {
  Form,
  FormItem,
  Message,
  Table,
  TableColumn,
  Loading,
  Button,
  Drawer,
  RadioGroup,
  Radio,
  RadioButton,
  Input,
  InputNumber,
  Tree,
  Select,
  Option,
  OptionGroup,
  Popover,
  Upload,
  CheckboxGroup,
  Checkbox,
  CheckboxButton,
  Tag,
  DatePicker,
  Cascader,
  CascaderPanel,
  Image,
  Tooltip, Steps, Step, TimePicker,
  Dialog,
  MessageBox,
  Tabs,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  Divider,
  Rate,
  Pagination,
  Card,
  Switch,
  Avatar,
  TimeSelect,
  Progress,
  Slider
} from 'element-ui'
const element = {
  install: function (Vue) {
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Loading)
    Vue.use(Loading.directive)
    Vue.use(Button)
    Vue.use(Drawer)
    Vue.use(RadioGroup)
    Vue.use(Radio)
    Vue.use(RadioButton)
    Vue.use(Input)
    Vue.use(InputNumber)
    Vue.use(Tree)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(OptionGroup)
    Vue.use(Popover)
    Vue.use(Upload)
    Vue.use(CheckboxGroup)
    Vue.use(Checkbox)
    Vue.use(CheckboxButton)
    Vue.use(Tag)
    Vue.use(DatePicker)
    Vue.use(Cascader)
    Vue.use(CascaderPanel)
    Vue.use(Tooltip)
    Vue.use(Steps)
    Vue.use(Step)
    Vue.use(TimePicker)
    Vue.use(Image)
    Vue.use(Dialog)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(Divider)
    Vue.use(Rate)
    Vue.use(Pagination)
    Vue.use(Card)

    // Vue.use(MessageBox)
    Vue.use(Switch)
    Vue.use(Avatar)
    Vue.use(TimeSelect)
    Vue.use(Progress)
    Vue.use(Slider)
    Vue.component(MessageBox.name, MessageBox);

    Vue.prototype.$message = Message
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$alert = MessageBox.alert
  }
}
export default element
